// Mixin padrão para a tabela
import TabelaMixin from "@/shared/mixin/TabelaMixin";

// Service
import TabelaErroService from "./TabelaErroService";

// Estilos da criticidade
import {
  enumCriticidade,
  enumStatusValidacaoNome
} from "../../../../../shared/helpers/Enum";

export default {
  mixins: [TabelaMixin, TabelaErroService],
  props: {
    idValidacao: {
      type: [String, Number],
      required: true
    },
    statusArquivo: {
      type: String
    }
  },
  data() {
    return {
      cabecalho: [
        {
          texto: "Desconsiderando"
        },
        {
          texto: "Linha"
        },
        {
          texto: "Elemento"
        },
        {
          texto: "Prestador"
        },
        {
          texto: "CNPJ"
        },
        {
          texto: "Criticidade"
        }
      ],
      arrNovaLinha: [],
      mapValoresCheck: new Map(),
      selecionados: []
    };
  },
  beforeMount() {
    this.iniciarTabela();
  },
  methods: {
    limparCheck() {
      this.selecionados = [];
      this.mapValoresCheck.clear();
    },
    /**
     * @param {Array<Number>} valores
     */
    marcarCheck(valores) {
      if (valores.length === 0) {
        this.$emit("check", []);
        return;
      }

      valores.forEach(valor => {
        if (this.mapValoresCheck.has(valor)) {
          return;
        }

        const linha = this.rows.find(
          row => row.naoMostrar.valorCheckbox === valor
        );

        if (linha) {
          this.mapValoresCheck.set(valor, linha.naoMostrar.desconsiderar);
        }
      });

      this.$emit("check", valores);
      this.$emit("mapValoresCheck", this.mapValoresCheck);
    },
    /**
     * Método que retorna o objeto formato para a criação das novas linhas
     * @param {String} html - Texto que é convertido para html
     */
    estiloNovaLinha(html) {
      return {
        styleLinha: {
          background: "rgb(243, 243, 243)"
        },
        styleDiv: {
          color: "#60656c",
          "padding-left": "20px"
        },
        styleMostrarLinha: {
          color: "#00995D"
        },
        corTriangulo: "rgb(243, 243, 243)",
        html
      };
    },
    /**
     * Método que retorna o objeto formatado para a criação das linhas na tabela
     * @param {{ campo: { chave: String, descricao: String}, conteudo: String, cpfCnpjPrestador: String, criticidade: {chave: String, descricao: String}, dsErro: String, id: Number, nmPrestador: String, nrLinha: Number }} elemento - Objeto que é retornado do back
     */
    estiloLinha(elemento) {
      return {
        desconsiderar: elemento.desconsiderar ? "Sim" : "Não",
        linha: elemento.nrLinha,
        elemento: {
          textoEstilo: elemento.campo.descricao,
          estiloTexto: {
            color: "red"
          }
        },
        prestador: elemento.nmPrestador,
        cnpj: {
          textoEstilo:
            elemento.cpfCnpjPrestador == null
              ? "-"
              : this.$helpers.formatarCampoCpfCnpj(elemento.cpfCnpjPrestador),
          estiloTexto: {
            color: "#9E9E9E"
          }
        },
        criticidade: enumCriticidade[elemento.criticidade.chave],
        novaLinha: true,
        novaLinhaTexto: "Instrução",
        naoMostrar: {
          naoAparece: true,
          valorCheckbox: elemento.id,
          desconsiderar: elemento.desconsiderar
        }
      };
    },
    /**
     * Método padrão para a criação de tabelas pelo sistema
     */
    iniciarTabela() {
      return new Promise((resolve, reject) => {
        this.loadingTabela = true;
        this.getAllErrosListagem(this.idValidacao, this.objetoTabelaComputed)
          .then(res => {
            const {
              conteudo,
              numeroPagina,
              tamanhoPagina,
              totalElementos,
              totalPaginas
            } = res.data;
            this.montarTabela(conteudo);
            this.pagina = numeroPagina;
            this.itemSelecionado = tamanhoPagina;
            this.qtResultados = totalElementos;
            this.qtPaginas = totalPaginas;
            this.$emit("quantidadeTotal", totalElementos);
            resolve();
          })
          .catch(() => {
            reject();
          })
          .finally(() => {
            this.loadingTabela = false;
          });
      });
    },
    /**
     * Método para montar a tabela de erros
     * @param {Array<{ campo: { chave: String, descricao: String}, conteudo: String, cpfCnpjPrestador: String, criticidade: {chave: String, descricao: String}, dsErro: String, id: Number, nmPrestador: String, nrLinha: Number>} rows
     */
    montarTabela(rows) {
      this.rows = [];
      this.arrNovaLinha = [];
      rows.forEach(e => {
        this.rows.push(this.estiloLinha(e));
        this.arrNovaLinha.push(
          this.estiloNovaLinha(`<span> ${e.dsErro} </span>`)
        );
      });
    }
  },
  computed: {
    /**
     * Retorna true se o status do arquivo for diferente de PROCESSANDO e a quantidade de erros for maior que 0
     * @return {Boolean}
     */
    mostrarBotaoExportar() {
      if ([undefined, null].includes(this.statusArquivo)) return false;
      return (
        enumStatusValidacaoNome[this.statusArquivo] !==
          enumStatusValidacaoNome.PROCESSANDO && this.qtResultados > 0
      );
    },
    mostrarCheck() {
      return (
        enumStatusValidacaoNome[this.statusArquivo] ===
        enumStatusValidacaoNome.PENDENTE
      );
    }
  }
};
